"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiscountAmountOffText = void 0;
var getDiscountAmountOffText = function (discount, formatter) {
    if (discount.amountType === "percentage") {
        return "".concat(discount.amount, "% off");
    }
    if (discount.amountType === "flat") {
        return "".concat(formatter.format(discount.amount), " off");
    }
    return "";
};
exports.getDiscountAmountOffText = getDiscountAmountOffText;
